import React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/sessionActions";
import PasswordForgetForm from "../components/PasswordForgetForm";

class PasswordForget extends React.Component {
  state = {
    email: "",
    touched: false,
  };

  isValidEmail = (email) => {
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return reg.test(email);
  };

  onSubmit = async (e) => {
    e.preventDefault();

    if (!this.isValidEmail(this.state.email)) {
      this.setState({ touched: true });
      return;
    }

    try {
      const result = await this.props.ForgetPassword(this.state.email);
      if (result.ok) {
        this.props.history.replace("/password_forget_send");
      } else {
        const errorKey =
          result.error === "user_wrong" ? "password_forget_not_found" : result.error;
        alertify.warning(I18n.t(errorKey));
      }
    } catch (error) {
      console.log(error);
      alertify.warning(I18n.t("try_later"));
    }
  };

  handleChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleBlur = () => {
    this.setState({ touched: true });
  };

  render() {
    const submitDisabled = !this.isValidEmail(this.state.email);

    return (
      <PasswordForgetForm
        email={this.state.email}
        touched={this.state.touched}
        submitDisabled={submitDisabled}
        loading={this.props.loading}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onSubmit={this.onSubmit}
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    error: reducer.session.error,
    success: reducer.session.success,
    loading: reducer.session.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  ForgetPassword: (email) => dispatch(actions.forgetPassword({ email })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordForget);
